export const GET_EXCO_PROVINSI = "GET_EXCO_PROVINSI";
export const GET_EXCO_PROVINSI_SUCCESS = "GET_EXCO_PROVINSI_SUCCESS";
export const GET_EXCO_PROVINSI_FAIL = "GET_EXCO_PROVINSI_FAIL";
